import React from 'react';

interface IconProps {
  color?: string;
  isSidebarIcon?: boolean;
  strokeColor?: string; // dodany prop dla koloru w sidebarze
}

const SettingsIcon: React.FC<IconProps> = ({
  color = '#007EC3',
  isSidebarIcon,
  strokeColor = '#CBD2D9', // domyślny kolor dla sidebara
}) => {
  if (isSidebarIcon) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.8668 20C25.5037 20.8228 25.6779 21.7837 26.3068 22.4266L26.3868 22.5066C26.8876 23.0068 27.1689 23.6856 27.1689 24.3933C27.1689 25.1011 26.8876 25.7798 26.3868 26.28C25.8866 26.7807 25.2079 27.0621 24.5002 27.0621C23.7924 27.0621 23.1137 26.7807 22.6135 26.28L22.5335 26.2C21.8906 25.5711 20.9296 25.3968 20.1068 25.76C19.3009 26.1054 18.777 26.8965 18.7735 27.7733V28C18.7735 29.4727 17.5796 30.6666 16.1068 30.6666C14.6341 30.6666 13.4402 29.4727 13.4402 28V27.88C13.419 26.9769 12.848 26.1785 12.0002 25.8666C11.1774 25.5035 10.2164 25.6778 9.5735 26.3066L9.4935 26.3866C8.99331 26.8874 8.31459 27.1687 7.60683 27.1687C6.89907 27.1687 6.22034 26.8874 5.72016 26.3866C5.21942 25.8865 4.93806 25.2077 4.93806 24.5C4.93806 23.7922 5.21942 23.1135 5.72016 22.6133L5.80016 22.5333C6.42905 21.8904 6.60329 20.9294 6.24016 20.1066C5.89474 19.3007 5.10369 18.7768 4.22683 18.7733H4.00016C2.5274 18.7733 1.3335 17.5794 1.3335 16.1066C1.3335 14.6339 2.5274 13.44 4.00016 13.44H4.12016C5.02327 13.4189 5.82168 12.8478 6.1335 12C6.49662 11.1772 6.32238 10.2162 5.6935 9.57331L5.6135 9.49331C5.11276 8.99313 4.8314 8.3144 4.8314 7.60665C4.8314 6.89889 5.11276 6.22016 5.6135 5.71998C6.11368 5.21924 6.7924 4.93788 7.50016 4.93788C8.20792 4.93788 8.88665 5.21924 9.38683 5.71998L9.46683 5.79998C10.1097 6.42887 11.0707 6.60311 11.8935 6.23998H12.0002C12.8061 5.89456 13.33 5.1035 13.3335 4.22665V3.99998C13.3335 2.52722 14.5274 1.33331 16.0002 1.33331C17.4729 1.33331 18.6668 2.52722 18.6668 3.99998V4.11998C18.6703 4.99684 19.1942 5.78789 20.0002 6.13331C20.8229 6.49644 21.7839 6.3222 22.4268 5.69331L22.5068 5.61331C23.007 5.11257 23.6857 4.83122 24.3935 4.83122C25.1013 4.83122 25.78 5.11257 26.2802 5.61331C26.7809 6.11349 27.0623 6.79222 27.0623 7.49998C27.0623 8.20774 26.7809 8.88646 26.2802 9.38665L26.2002 9.46665C25.5713 10.1096 25.397 11.0705 25.7602 11.8933V12C26.1056 12.8059 26.8966 13.3298 27.7735 13.3333H28.0002C29.4729 13.3333 30.6668 14.5272 30.6668 16C30.6668 17.4727 29.4729 18.6666 28.0002 18.6666H27.8802C27.0033 18.6701 26.2123 19.194 25.8668 20Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4 15.5C19.1277 16.1171 19.2583 16.8378 19.73 17.32L19.79 17.38C20.1656 17.7551 20.3766 18.2642 20.3766 18.795C20.3766 19.3258 20.1656 19.8349 19.79 20.21C19.4149 20.5856 18.9058 20.7966 18.375 20.7966C17.8442 20.7966 17.3351 20.5856 16.96 20.21L16.9 20.15C16.4178 19.6783 15.6971 19.5477 15.08 19.82C14.4755 20.0791 14.0826 20.6724 14.08 21.33V21.5C14.08 22.6046 13.1846 23.5 12.08 23.5C10.9754 23.5 10.08 22.6046 10.08 21.5V21.41C10.0642 20.7327 9.63587 20.1339 9 19.9C8.38291 19.6277 7.66219 19.7583 7.18 20.23L7.12 20.29C6.74486 20.6656 6.23582 20.8766 5.705 20.8766C5.17418 20.8766 4.66514 20.6656 4.29 20.29C3.91445 19.9149 3.70343 19.4058 3.70343 18.875C3.70343 18.3442 3.91445 17.8351 4.29 17.46L4.35 17.4C4.82167 16.9178 4.95235 16.1971 4.68 15.58C4.42093 14.9755 3.82764 14.5826 3.17 14.58H3C1.89543 14.58 1 13.6846 1 12.58C1 11.4754 1.89543 10.58 3 10.58H3.09C3.76733 10.5642 4.36613 10.1359 4.6 9.5C4.87235 8.88291 4.74167 8.16219 4.27 7.68L4.21 7.62C3.83445 7.24486 3.62343 6.73582 3.62343 6.205C3.62343 5.67418 3.83445 5.16514 4.21 4.79C4.58514 4.41445 5.09418 4.20343 5.625 4.20343C6.15582 4.20343 6.66486 4.41445 7.04 4.79L7.1 4.85C7.58219 5.32167 8.30291 5.45235 8.92 5.18H9C9.60447 4.92093 9.99738 4.32764 10 3.67V3.5C10 2.39543 10.8954 1.5 12 1.5C13.1046 1.5 14 2.39543 14 3.5V3.59C14.0026 4.24764 14.3955 4.84093 15 5.1C15.6171 5.37235 16.3378 5.24167 16.82 4.77L16.88 4.71C17.2551 4.33445 17.7642 4.12343 18.295 4.12343C18.8258 4.12343 19.3349 4.33445 19.71 4.71C20.0856 5.08514 20.2966 5.59418 20.2966 6.125C20.2966 6.65582 20.0856 7.16486 19.71 7.54L19.65 7.6C19.1783 8.08219 19.0477 8.80291 19.32 9.42V9.5C19.5791 10.1045 20.1724 10.4974 20.83 10.5H21C22.1046 10.5 23 11.3954 23 12.5C23 13.6046 22.1046 14.5 21 14.5H20.91C20.2524 14.5026 19.6591 14.8955 19.4 15.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SettingsIcon;
